export default __webpack_public_path__ + "static/media/Q12025.ad8d80dc.pdf";